import React from "react";
import VisionImg from "../../assets/img/about-us/vision.jpeg";
const Vision = () => {
    return (
    
        <div className="container p-5 my-4">
          <div className="row ">
            {/* Image Content */}
            <div className="col-md-6 ">
                <img
                src={VisionImg}
                alt="Car Marketplace"
                className="img-fluid rounded shadow-lg"
                style={{ maxWidth: "80%", height: "auto" }}
                />
            </div>
            {/* Text Content */}
            <div className="col-md-6 text-dark ">
              <h5 className="display-6 pb-2 mb-4">
                Vision
              </h5>
              <p>
              To be the preferred Singapore automotive auction platform, offering a fair, 
              unique and exciting journey on your car ownership.
            </p>
            </div>
         
          </div>
          </div>
        
      
    );
  };
  
  export default Vision;